export default __webpack_public_path__ + "static/media/stripe.77e972cd.svg";